<template>
  <chart
    :width="width"
    :height="height"
    :chart-data="chartData"
    :options="options"
  />
</template>
<script>
import Chart from '@/components/charts/Chart'

export default {
  name: 'ReachFrequencyChart',
  components: {
    Chart
  },
  props: {
    width: {
      type: Number,
      default: undefined
    },
    height: {
      type: Number,
      default: undefined
    },
    report: {
      type: Array,
      default: null
    },
    precision: { // 小数点第何位まで表示するか決める
      type: Number,
      default: 0
    },
    labelField: {
      type: String,
      default: 'firstViewDate'
    }
  },
  computed: {
    chartData () {
      return {
        labels: this.report.map(item => item[this.labelField]),
        datasets: [
          {
            type: 'bar',
            label: 'リーチ',
            borderWidth: 2,
            data: this.report.map(item => item.reach),
            yAxisID: 'reach'
          },
          {
            type: 'line',
            label: 'フリークエンシー',
            borderWidth: 2,
            pointRadius: 2,
            data: this.report.map(item => item.frequency),
            yAxisID: 'frequency'
          }
        ]
      }
    },
    options () {
      return {
        plugins: {
          tooltip: {
            mode: 'index',
            position: 'nearest',
            callbacks: {
              label (tooltipItem) {
                if (tooltipItem.raw === 0) {
                  return ''
                }
                const label = tooltipItem.dataset.label
                const value = tooltipItem.formattedValue
                if (label.includes('率')) {
                  return `${label}: ${value}%`
                }
                return `${label}: ${value}`
              }
            }
          }
        },
        maintainAspectRatio: false,
        scales: {
          x: {
            stacked: true
          },
          reach: {
            stacked: false,
            position: 'left',
            suggestedMin: 0,
            ticks: {
              callback (value) {
                return `${value.toLocaleString()}`
              }
            }
          },
          frequency: {
            stacked: false,
            position: 'right',
            suggestedMin: 0,
            ticks: {
              callback (value) {
                return `${value.toLocaleString()}`
              }
            }
          }
        }
      }
    }
  }

}
</script>

<style scoped>
</style>
